import React from 'react'
import { PaginaNode } from '@gql/graphql'
import { ListingHead, ManualiForm, Page } from 'components/organisms'
import styles from './ManualiTemplate.module.sass'
import { PlaceholderReact } from '@components/molecules'

interface Props {
  pagina?: PaginaNode
  mainContent?: any
}

const ManualiTemplate = (props: Props) => {
  const { pagina = undefined, mainContent = undefined } = props

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <ListingHead pagina={pagina} />
        <div className={styles.main}>
          <ManualiForm />
          <PlaceholderReact
            contentTypeId={pagina.model}
            objectId={pagina.pk}
            pkey={'main'}
            serverSideContent={mainContent}
          />
        </div>
      </main>
    </Page>
  )
}

export default ManualiTemplate
